import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=3877aa6e&scoped=true"
import script from "./classify.vue?vue&type=script&lang=ts"
export * from "./classify.vue?vue&type=script&lang=ts"
import style0 from "./classify.vue?vue&type=style&index=0&id=3877aa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877aa6e",
  null
  
)

export default component.exports